import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles/occThankYou.scss';
// import { useOCC } from './context/occContext';
import FormattedRichMessage from '../common/FormattedRichMessages';
const OCCErrorPage = () => /*#__PURE__*/React.createElement("div", {
  className: styles.occ_thankyou_container
}, /*#__PURE__*/React.createElement("h1", {
  className: styles.occ_title
}, /*#__PURE__*/React.createElement(FormattedRichMessage, {
  id: "occError.title"
})), /*#__PURE__*/React.createElement("p", {
  className: styles.occ_subtitle
}, /*#__PURE__*/React.createElement(FormattedRichMessage, {
  id: "occError.subtitle"
})), /*#__PURE__*/React.createElement("p", {
  className: styles.occ_text
}, /*#__PURE__*/React.createElement(FormattedRichMessage, {
  id: "occError.contactUs"
})), /*#__PURE__*/React.createElement("p", {
  className: styles.occ_text
}, /*#__PURE__*/React.createElement(FormattedRichMessage, {
  id: "occError.profileAndPreferences"
})), /*#__PURE__*/React.createElement("div", {
  className: styles.occ_links
}, /*#__PURE__*/React.createElement(Link, {
  to: "/email-safety"
}, /*#__PURE__*/React.createElement(FormattedRichMessage, {
  id: "occError.linkText1"
})), /*#__PURE__*/React.createElement(Link, {
  to: "/add-to-address-book"
}, /*#__PURE__*/React.createElement(FormattedRichMessage, {
  id: "occError.linkText2"
})), /*#__PURE__*/React.createElement(Link, {
  to: "/summary-of-accounts"
}, /*#__PURE__*/React.createElement(FormattedRichMessage, {
  id: "occError.linkText3"
}))));
export default OCCErrorPage;